exports.install = function (Vue, options) {
  // 图片上传
  Vue.prototype.$uploadImage = function (fileObj, imgType, _this,refNmae) {
    _this.submitLoading = true;
    if (fileObj.file.size > 1024 * 1024 * 10) {
        _this.$refs[refNmae].clearFiles();
        _this.$message.warning(
          "文件不符合规则（图片大小不超过 10M），请重新上传~"
        );
        _this.submitLoading = false;
        return;
    }
    const formData = new FormData()
    formData.append('file', fileObj.file)
    _this.$api.upload.uploadFile(formData).then((res) => {
      if (res.code === 0) {
        _this.form[imgType].push({
          name: fileObj.file.name,
          url: res.data[0]
        })
      }
      _this.submitLoading = false;

    })
    .catch((error) => {
      _this.submitLoading = false;

      if (error.response?.status == 400) {
        _this.$message.warning("请上传jpg、png格式的图片");
        _this.form[imgType] = [];
      }
    });
  }

  Vue.prototype.$uploadFile = function (fileObj, imgType, _this,refNmae) {
    _this.submitLoading = true;
    if (fileObj.file.size > 1024 * 1024 * 10) {
        _this.$refs[refNmae].clearFiles();
        _this.$message.warning(
          "文件不符合规则（大小不超过 10M），请重新上传~"
        );
        _this.submitLoading = false;
        return;
    }
    const formData = new FormData()
    formData.append('file', fileObj.file)
    _this.$api.upload.uploadFile(formData).then((res) => {
      if (res.code === 0) {
        _this.form[imgType].push({
          
          name: fileObj.file.name,
          url: res.data[0]
        })

      }
      _this.submitLoading = false;

    })
    .catch((error) => {
      _this.submitLoading = false;

      if (error.response?.status == 400) {
        _this.$message.warning("请上传正确的格式！");
        _this.form[imgType] = [];
      }
    });
  }

}

